import type { LucideIcon } from "lucide-react"
import { Building2, FileText, Package, Truck, UserRound } from "lucide-react"
import type { ReactNode } from "react"

import { CargasAsignadas } from "@/componentes/transporte/CargasAsignadas"
import { Catalogo, type Clase } from "@/componentes/transporte/Catalogo"
import { Recibos } from "@/componentes/transporte/Recibos"

/**
 * Las pantallas del portal de transporte (`transporte.<dominio>`, 25/10).
 *
 * ⚠ **Es el MISMO sistema, no una página aparte** (pedido del usuario: «como herramienta
 * del 3.0 debe conservar la misma apariencia y estilo, eso incluye el login»). En ese host,
 * `main.tsx` monta el acceso, la fotografía y el armazón de siempre (`AppShell`) con estas
 * rutas; la barra lateral le da a la cuenta TRANSPORTISTA su menú fijo y el encabezado
 * esconde lo que es del personal. El aislamiento lo hace el servidor (`deps.portal_admite`).
 */

function Pantalla({
  icono: Icono,
  titulo,
  subtitulo,
  children,
}: {
  icono: LucideIcon
  titulo: string
  subtitulo: string
  children: ReactNode
}) {
  return (
    <div className="space-y-4">
      <header>
        <h1 className="flex items-center gap-2 text-xl font-semibold">
          <Icono size={20} aria-hidden={true} /> {titulo}
        </h1>
        <p className="text-sm" style={{ color: "var(--fg-muted)" }}>
          {subtitulo}
        </p>
      </header>
      {children}
    </div>
  )
}

export function PaginaCargas() {
  return (
    <Pantalla
      icono={Package}
      titulo="Cargas asignadas"
      subtitulo="Los fletes que SETIECA le asignó, con su expediente, su BL y su mercancía."
    >
      <CargasAsignadas />
    </Pantalla>
  )
}

export function PaginaRecibos() {
  return (
    <Pantalla
      icono={FileText}
      titulo="Recibos"
      subtitulo="El historial de los fletes que coordinó, con su número y su PDF."
    >
      <Recibos />
    </Pantalla>
  )
}

const CATALOGO: Record<Clase, { icono: LucideIcon; titulo: string; subtitulo: string }> = {
  EMPRESA: {
    icono: Building2,
    titulo: "Empresas de transporte",
    subtitulo: "Las empresas que hacen los fletes, con su RIF, su logo y sus documentos.",
  },
  VEHICULO: {
    icono: Truck,
    titulo: "Vehículos",
    subtitulo: "Chutos y remolques, con su carnet de circulación y su póliza RCV.",
  },
  CHOFER: {
    icono: UserRound,
    titulo: "Choferes",
    subtitulo: "Los choferes, con su cédula y su licencia de conducir.",
  },
}

export function PaginaCatalogo({ clase }: { clase: Clase }) {
  const c = CATALOGO[clase]
  return (
    <Pantalla icono={c.icono} titulo={c.titulo} subtitulo={c.subtitulo}>
      <Catalogo key={clase} clase={clase} />
    </Pantalla>
  )
}
